import { Box, Typography } from "@mui/material";
import { useCompanyInfo } from "../../hooks";
import { FullLogo, WealthXLogoSmall } from "../../images";
import "./partner-logo-banner.scss";

const PartnerLogoBanner = () => {
  const { data: companyInfo } = useCompanyInfo();
  const logoUrl =
    companyInfo?.theme?.logoDarkUrl || companyInfo?.theme?.logoUrl || "";
  if (!logoUrl) {
    return (
      <img className="partner-logo-banner__logo" src={FullLogo} alt="logo" />
    );
  }
  return (
    <Box className="partner-logo-banner__banner">
      <img className="partner-logo-banner__logo" src={logoUrl} alt="logo" />
      <Box className="partner-logo-banner__powered-by">
        <Typography className="partner-logo-banner__powered-by-text">
          Powered by
        </Typography>
        <img
          className="partner-logo-banner__wealthx-logo"
          src={WealthXLogoSmall}
          alt="wealthx"
        />
      </Box>
    </Box>
  );
};

export default PartnerLogoBanner;
